'use strict';

var React = require('react');
require('prop-types');
var withStyles = require('../../../../DesignSystem/Styles/withStyles.js');
var InformativeTooltip = require('../../../../DesignSystem/DataDisplay/Tooltips/InformativeTooltip.js');
var Typography = require('../../../../DesignSystem/DataDisplay/Typography/Typography.js');
require('../../../../library/DataDisplay/SvgIcon.js');
require('../../../../IconsAndImages/iconStyles.js');
var Sparky = require('../../../../IconsAndImages/Icons/Sparky.js');
var IconButton = require('../../../../DesignSystem/Inputs/Buttons/IconButton.js');
var ObjectHelper = require('../../../../common/ObjectHelper.js');
var Theme = require('../../../../Theme/Theme.js');
require('../../../../Theme/DarkTheme.js');
require('../../../../Theme/LightTheme.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  allocationButton: {
    padding: 4,
    '&:hover': {
      '& svg': {
        fill: Theme.theme.palette.primary.main
      }
    }
  },
  allocation: {
    width: 24,
    height: 24,
    paddingTop: 2
  }
};

var ReviewsAllocationButton = function ReviewsAllocationButton(_ref) {
  var classes = _ref.classes,
      allocation = _ref.allocation,
      onClick = _ref.onClick,
      title = _ref.title,
      subtitle = _ref.subtitle;
  return React__default["default"].createElement(InformativeTooltip, {
    placement: "bottom-end",
    title: ObjectHelper.isPresent(title) || ObjectHelper.isPresent(subtitle) ? React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(Typography, {
      variant: "body1"
    }, title), React__default["default"].createElement(Typography, {
      variant: "caption",
      color: "secondary"
    }, subtitle)) : ''
  }, React__default["default"].createElement(IconButton, {
    className: classes.allocationButton,
    onClick: onClick
  }, isNaN(allocation) ? React__default["default"].createElement(Sparky, null) : React__default["default"].createElement(Typography, {
    variant: "body2",
    className: classes.allocation
  }, allocation, "%")));
};

var ReviewsAllocationButton$1 = withStyles["default"](styles)(ReviewsAllocationButton);

module.exports = ReviewsAllocationButton$1;
